const state = {
    sector:{

    },
    objective:{},
    groups:[],
    periods:[],
    treeViewSector: []
}

const mutations = {
    setSector(base, sectorInd){
        base.sector = sectorInd;
    },
    setGroups(base, groups){
        base.groups = groups;
    },
    addGroups(base, group){
        base.groups.push(group);
    },
    setPeriods(base, periods){
        base.periods = periods;
    },
    setTree(base, data){
        base.treeViewSector = data;
    }
}

const getters = {
    getGroups(base){
        return base.groups.filter(x=>x.state === '1').sort((a,b) => a.id - b.id)
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    getters
}